// Shopify variant button activator
function activateVariantButtons() {
  const labels = document.querySelectorAll(".f-button__list__link.rounded");

  if (!labels.length) return false;

  labels.forEach((label) => {
    const inputId = label.getAttribute("for");
    const input = document.getElementById(inputId);
    if (!input) return;

    // ✅ Apply default "is-active" on load
    if (input.checked) label.classList.add("is-active");

    // Remove any previously bound event to avoid duplicates
    label.replaceWith(label.cloneNode(true));
  });

  // Requery since we cloned elements above
  const freshLabels = document.querySelectorAll(".f-button__list__link.rounded");
  freshLabels.forEach((label) => {
    const inputId = label.getAttribute("for");
    const input = document.getElementById(inputId);
    if (!input) return;

    label.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      // ✅ Allow immediate click even during hover animations
      requestAnimationFrame(() => {
        const fieldset = label.closest("fieldset");
        if (!fieldset) return;

        // Remove active from all in same fieldset
        fieldset.querySelectorAll(".f-button__list__link.rounded")
          .forEach((lbl) => lbl.classList.remove("is-active"));

        // Add active to clicked
        label.classList.add("is-active");

        // Update input
        input.checked = true;

        // Trigger Shopify’s built-in handlers
        input.dispatchEvent(new Event("change", { bubbles: true }));
        input.dispatchEvent(new Event("input", { bubbles: true }));

        // For themes with dynamic reloads (like Prestige/Impulse)
        document.querySelectorAll("[data-product-form]").forEach((form) => {
          if (typeof form.onVariantChange === "function") {
            form.onVariantChange();
          }
        });
      });
    });
  });

  return true;
}

// Reinitialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  const observer = setInterval(() => {
    const ready = activateVariantButtons();
    if (ready) clearInterval(observer);
  }, 300);
});

// Re-run when Shopify dynamically replaces variant DOM
document.addEventListener("shopify:section:load", activateVariantButtons);
document.addEventListener("shopify:section:select", activateVariantButtons);

// Swiper Bullets JS
const swiper = new Swiper('.wt-slider', {
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true, // ✅ make bullets clickable
  },
});
